(() => {
  const normalize = (value = '') => value.trim().toLowerCase();

  const initAcademy = (academy) => {
    if (!academy || academy.dataset.veaoReady === 'true') return;
    academy.dataset.veaoReady = 'true';

    const overview = academy.querySelector('[data-veao-overview]');
    const profiles = [...academy.querySelectorAll('[data-veao-profile]')];
    const courseSelect = academy.querySelector('[data-veao-course-select]');
    const educatorSelect = academy.querySelector('[data-veao-educator-select]');
    const defaultTitle = document.title;

    const profileFor = (slug) => profiles.find((profile) => normalize(profile.dataset.veaoProfile) === normalize(slug));

    const updateUrl = (slug, mode = 'push') => {
      const url = new URL(window.location.href);
      if (slug) url.searchParams.set('educator', slug);
      else url.searchParams.delete('educator');
      const method = mode === 'replace' ? 'replaceState' : 'pushState';
      window.history[method]({ veaoEducator: slug || null }, '', url);
    };

    const showOverview = ({ updateHistory = false, scroll = false } = {}) => {
      if (overview) overview.hidden = false;
      profiles.forEach((profile) => { profile.hidden = true; });
      document.documentElement.classList.remove('veao-profile-mode');
      document.title = defaultTitle;
      if (updateHistory) updateUrl('', 'push');
      if (scroll) window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const showProfile = (slug, { updateHistory = false, scroll = false } = {}) => {
      const profile = profileFor(slug);
      if (!profile) return false;
      if (overview) overview.hidden = true;
      profiles.forEach((item) => { item.hidden = item !== profile; });
      document.documentElement.classList.add('veao-profile-mode');
      const title = profile.dataset.pageTitle;
      if (title) document.title = `${title} - VALID EDGE Academy`;
      if (updateHistory) updateUrl(slug, 'push');
      if (scroll) { window.scrollTo({ top: 0, behavior: 'smooth' }); const heading = profile.querySelector('h1'); if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); } }
      return true;
    };

    academy.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const explore = event.target.closest('[data-veao-explore]');
      if (explore) {
        const slug = explore.dataset.veaoExplore;
        if (!profileFor(slug)) return;
        event.preventDefault();
        showProfile(slug, { updateHistory: true, scroll: true });
        return;
      }

      const back = event.target.closest('[data-veao-back]');
      if (back) {
        event.preventDefault();
        showOverview({ updateHistory: true, scroll: true });
        return;
      }

      const coursePick = event.target.closest('[data-veao-course-pick]');
      if (coursePick && courseSelect) {
        const courseName = coursePick.dataset.veaoCoursePick || '';
        courseSelect.value = courseName;
        const course = coursePick.closest('.veao-course');
        const selectedEducator = course ? course.querySelector('[data-veao-course-educator-option]:checked') : null;
        if (educatorSelect) educatorSelect.value = selectedEducator ? selectedEducator.value : 'No preference';
      }
    });

    academy.addEventListener('change', (event) => {
      const picker = event.target.closest('[data-veao-course-educator-option]');
      if (!picker) return;

      const course = picker.closest('.veao-course');
      const educatorName = picker.value || 'No preference';
      const courseName = picker.dataset.courseName || '';
      const label = course ? course.querySelector('[data-veao-course-educator-label]') : null;

      if (label) {
        label.textContent = educatorName === 'No preference'
          ? 'NO PREFERENCE'
          : `WITH ${educatorName.toUpperCase()}`;
      }
      if (educatorSelect) educatorSelect.value = educatorName;
      if (courseSelect && courseName) courseSelect.value = courseName;
    });

    if (educatorSelect) {
      educatorSelect.addEventListener('change', () => {
        const courseName = courseSelect ? courseSelect.value : '';
        if (!courseName) return;
        const course = [...academy.querySelectorAll('.veao-course')].find((item) => {
          const picker = item.querySelector('[data-veao-course-educator-option]');
          return picker && picker.dataset.courseName === courseName;
        });
        if (!course) return;
        const value = educatorSelect.value || 'No preference';
        const option = [...course.querySelectorAll('[data-veao-course-educator-option]')].find((input) => input.value === value);
        if (option) option.checked = true;
        const label = course.querySelector('[data-veao-course-educator-label]');
        if (label) label.textContent = value === 'No preference' ? 'NO PREFERENCE' : `WITH ${value.toUpperCase()}`;
      });
    }

    const applyRoute = ({ replaceInvalid = false } = {}) => {
      const params = new URLSearchParams(window.location.search);
      const slug = params.get('educator');
      if (slug && showProfile(slug)) return;
      showOverview();
      if (slug && replaceInvalid) updateUrl('', 'replace');
    };

    window.addEventListener('popstate', () => applyRoute());
    applyRoute({ replaceInvalid: true });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-veao-academy]').forEach(initAcademy);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
